{
	"title": "Zakelijk bestellen",
	"description": "Voor schoonmaakbedrijven, kantoren en hotels: prijzen excl. btw, betalen op rekening en korting op grote aantallen. Vraag een zakelijk account aan.",
	"breadcrumbs": "Kruimelpad",
	"home": "Home",
	"lead": "Voor schoonmaakbedrijven, kantoren en hotels: dezelfde navulling, met prijzen excl. btw, betalen op rekening en korting op grote aantallen.",
	"who": {
		"cleaning": "Schoonmaakbedrijven",
		"offices": "Kantoren",
		"hotels": "Hotels"
	},
	"terms": {
		"paymentTerm": "{{days}} dagen",
		"paymentTermOpen": "[NOG INVULLEN: 14 of 30] dagen",
		"quantityDiscount": "[NOG INVULLEN: staffel]",
		"reviewTime": "[NOG INVULLEN: X werkdagen]",
		"largerPacks": "[NOG INVULLEN: bevestigen]"
	},
	"status": {
		"label": "Je zakelijke status",
		"loading": "Je aanvraag wordt geladen.",
		"guest": {
			"title": "Zakelijk account aanvragen",
			"text": "Maak eerst een account, of log in. Daarna doe je de zakelijke aanvraag met je kvk- en btw-nummer.",
			"register": "Account maken",
			"signIn": "Inloggen",
			"note": "Gewoon bestellen kan ook zonder aanvraag. Prijzen excl. btw zie je als je een account maakt en dat in je account kiest."
		},
		"noApplication": {
			"title": "Je zakelijke aanvraag",
			"signedInAs": "Ingelogd als {{email}}. Het duurt een paar minuten.",
			"companyPlaceholder": "Bijv. Schoonmaakbedrijf De Vries",
			"kvkPlaceholder": "12345678",
			"vatIdPlaceholder": "NL123456789B01",
			"submit": "Aanvraag versturen",
			"legal": "We beoordelen je aanvraag binnen $t(terms.reviewTime) en mailen je de uitkomst."
		},
		"pending": {
			"title": "Je aanvraag is in behandeling",
			"text": "Ingediend op {{date}}. Je hoort binnen $t(terms.reviewTime) per mail of je bent goedgekeurd.",
			"note": "Tot die tijd bestel je gewoon met iDEAL, Bancontact, creditcard of PayPal.",
			"sent": "Bedankt, we hebben je aanvraag ontvangen."
		},
		"approved": {
			"title": "Je bent goedgekeurd",
			"text": "Je ziet je eigen prijzen excl. btw en betaalt op rekening.",
			"pricesValue": "excl. btw, eigen prijs",
			"shop": "Naar de winkel",
			"orders": "Je bestellingen"
		},
		"rejected": {
			"title": "Je aanvraag is afgewezen",
			"noReason": "We konden je aanvraag niet goedkeuren.",
			"note": "Je kunt nog steeds bestellen met iDEAL, Bancontact, creditcard of PayPal. Prijzen excl. btw zie je als je dat in je account kiest, onder Gegevens.",
			"applyAgain": "Gegevens aanpassen en opnieuw aanvragen",
			"againTitle": "Opnieuw aanvragen",
			"contact": "Contact"
		}
	},
	"details": {
		"company": "Bedrijf",
		"kvk": "Kvk",
		"vatId": "Btw-nummer",
		"paymentTerm": "Betaaltermijn",
		"quantityDiscount": "Staffelkorting",
		"prices": "Prijzen"
	},
	"vies": "Gecontroleerd via VIES",
	"points": {
		"title": "Wat je krijgt",
		"text": "Vier dingen die alleen voor zakelijke klanten gelden.",
		"exclVat": {
			"title": "Prijzen excl. btw",
			"big": "excl. btw",
			"text": "Maak een account en kies in je account voor prijzen excl. btw. Na goedkeuring staat het er standaard op, met je eigen prijzen."
		},
		"onAccount": {
			"title": "Op rekening betalen",
			"text": "Na goedkeuring betaal je op factuur."
		},
		"quantityDiscount": {
			"title": "Staffelkorting",
			"text": "Korting die oploopt met het aantal pakken in één bestelling."
		},
		"bulk": {
			"title": "Grootverpakking",
			"big": "240 doekjes",
			"text": "Het grootste pak vloerdoekjes, standaard. Grotere formaten: $t(terms.largerPacks)."
		}
	},
	"steps": {
		"title": "Zo werkt het",
		"here": "Hier ben je",
		"done": "Klaar",
		"account": {
			"title": "Account maken",
			"text": "Met je e-mailadres en een wachtwoord."
		},
		"application": {
			"title": "Zakelijke aanvraag",
			"text": "Bedrijfsnaam, kvk- en btw-nummer. Het btw-nummer controleren we direct via VIES."
		},
		"approval": {
			"title": "Goedkeuring",
			"text": "Binnen $t(terms.reviewTime), per mail."
		},
		"order": {
			"title": "Bestellen",
			"text": "Met je eigen prijzen excl. btw, en op rekening."
		}
	},
	"contact": {
		"title": "Grote of vaste bestelling?",
		"text": "Bijvoorbeeld elke maand dezelfde pakken voor meerdere locaties. Neem contact op met Richard, dan maken we een afspraak.",
		"mail": "Mail {{email}}",
		"call": "Bel {{phone}}",
		"page": "Naar contact"
	}
}
